import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ItemView,
  ItemViewProviderDirective,
  log,
  NtapGlobalConstants,
  UIComponents,
  Util
} from '@ntap/core';
import { combineLatest, Subscription } from 'rxjs';

@Component({
  selector: 'app-prilozi-radnog-zadatka',
  templateUrl: './prilozi-radnog-zadatka.component.html',
  styleUrls: ['./prilozi-radnog-zadatka.component.scss']
})
export class PriloziRadnogZadatkaComponent implements OnInit, OnDestroy {
  INIT_COMP_ID = UIComponents.LISTVIEW;

  routeChangeSubscription: Subscription;

  currentListViewName: string;
  currentListViewState: object | null = null;
  currentListViewStateFilter: object = {};

  constructor(
    protected route: ActivatedRoute,
    protected parentItemProvider: ItemViewProviderDirective<ItemView>
  ) {}

  ngOnInit() {
    this.subscribeToRouteChange();
  }

  ngOnDestroy(): void {
    this.unsubscribeFromRouteChange();
  }

  subscribeToRouteChange() {
    log('subscribe to route params');
    this.routeChangeSubscription = combineLatest([
      this.route.paramMap,
      this.parentItemProvider.item$
    ]).subscribe(([, parentItem]: [params: any, parentItem: any]) => {
      log('param change');
      // TODO ovdje ce trebati dinamicki postaviti list view ovisno o vrsti radnog zadatka?
      this.changeView('jedinice_gradiva_za_verifikaciju', parentItem);
    });
  }

  unsubscribeFromRouteChange(): any {
    log('Unsubsubscribe from route params');
    if (this.routeChangeSubscription) {
      this.routeChangeSubscription.unsubscribe();
    }
  }

  changeView(viewName: string, parentItem: any) {
    log(`CHANGE NEW view: ${viewName}`);
    this.currentListViewName = viewName;
    this.currentListViewState = {
      [Util.getFullAttrName('ntap_task', NtapGlobalConstants.ATTR_id)]:
        parentItem[
          Util.getFullAttrName(
            parentItem[NtapGlobalConstants.ATTR_$mainType],
            NtapGlobalConstants.ATTR_id
          )
        ]
    };
    this.currentListViewStateFilter = {};
  }
}
